/* IMPORTS */
import React from "react";
import { Page } from "../page";
import { Waves } from "../waves";

export const WavesPage: React.FC<{}> = () => {
  return (
    <Page title="Waves">
      <Waves />
    </Page>
  );
};
